import styled, { css } from 'styled-components';
export var Wrapper = styled.div.withConfig({
  displayName: "ScrollWrapperstyles__Wrapper",
  componentId: "keen-query-creator__sc-1j9d88m-0"
})(["&&&{position:relative;", ";}"], function (props) {
  return props.maxHeight && css(["overflow-y:scroll;max-height:", "px;"], props.maxHeight);
});